import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Reusable liquid-glass bento card
export const GlassCard = ({ children, className = "", delay = 0, testId }) => (
  <motion.div
    data-testid={testId}
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    className={`lg-surface rounded-3xl ${className}`}
  >
    {children}
  </motion.div>
);

// Static device mockup inside a glass cell (no carousel).
// Swap the `src` later and the glass aesthetic is preserved automatically.
export const DeviceMock = ({ src, alt, className = "", imgClassName = "" }) => (
  <div className={`relative flex items-center justify-center ${className}`}>
    <div
      aria-hidden
      className="pointer-events-none absolute left-1/2 top-1/2 h-[72%] w-[72%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#6C63FF]/18 blur-[90px]"
    />
    <motion.img
      src={src}
      alt={alt}
      draggable={false}
      decoding="async"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.9, ease: EASE }}
      className={`relative z-10 w-auto select-none object-contain drop-shadow-[0_36px_70px_rgba(0,0,0,0.6)] ${imgClassName}`}
    />
  </div>
);

// Small glass pill / tag
export const GlassTag = ({ children, icon }) => (
  <span className="lg-pill inline-flex items-center gap-2 rounded-full px-4 py-2 font-accent text-sm text-white/90">
    {icon}
    {children}
  </span>
);
